import React from 'react';
import { RouteComponentProps } from '@reach/router';

import Layout from './Layout/Layout';

import IndexStyles from './Index.styles';

const Index: React.FC<RouteComponentProps> = () => (
  <Layout>
    <IndexStyles>
      <h2>Index</h2>
      <p>Use the navigation below!</p>
    </IndexStyles>
  </Layout>
);

export default Index;
